<script lang="ts">
	import { format } from 'svelte-i18n';

	import { ButtonV2, Icon, Text } from '@Shelly/shelly-design-system';

	import { app } from '../../stores';

	// Native Shelly app (iOS/Android WebView) — not browser width or mobile web.
	$: isNativeShellyApp = $app;

	function refreshApp() {
		window.location.reload();
	}
</script>

<div class="update-required" role="status">
	{#if isNativeShellyApp}
		<Icon icon="fas fa-mobile-screen-button" size="xl" class="update-required-icon" />
		<Text element="h1" class="text-center">
			{$format('ai_app_update_required_title', {
				default: "Update the app to use Shelly's AI assistant",
			})}
		</Text>
		<Text styleType="body" class="text-center text-color-muted">
			{$format('ai_app_update_required_description', {
				default: 'Download the latest Shelly Smart Control update, then try again.',
			})}
		</Text>
	{:else}
		<Icon icon="fas fa-rotate" size="xl" class="update-required-icon" />
		<Text element="h1" class="text-center">
			{$format('ai_web_refresh_required_title', {
				default: 'Refresh to update Shelly Assistant',
			})}
		</Text>
		<Text styleType="body" class="text-center text-color-muted">
			{$format('ai_web_refresh_required_description', {
				default:
					'Refresh the page to load the latest files. If the message remains, hard refresh your browser.',
			})}
		</Text>
		<ButtonV2
			variant="primary"
			size="m"
			on:click={refreshApp}
			aria-label={$format('ai_web_refresh_button_aria_label', {
				default: 'Refresh Shelly Smart Control',
			})}
		>
			{$format('refresh', { default: 'Refresh' })}
		</ButtonV2>
	{/if}
</div>

<style>
	.update-required {
		display: flex;
		flex: 1;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: var(--spacing-m);
		padding: var(--spacing-xl);
	}

	.update-required :global(.update-required-icon) {
		color: var(--color-primary);
	}
</style>
